// TODO: get from api
export const LLM_TYPES = [
    'openai-gpt-3.5-turbo',
    'openai-gpt-3.5-turbo-azure',
    'openai-gpt-4',
    'openai-gpt-4-azure',
    'google-palm'
];

export const topAnswers = [1, 2, 3];
export const defaultResponseLLM = LLM_TYPES[0];
export const defaulttopAnswers = topAnswers[0];

export const DOMAIN = 'generic';
export const BOT_TYPE = 'Business';
export const BOT_NAME_MAX_LENGTH = 50;
export const BOT_PERSONALITY_MAX_LENGTH = 2000;
export const BOT_GREETING_MESSAGE_MAX_LENGTH = 250;
export const API_INTENT_NAME_MAX_LENGTH = 50;
export const API_INTENT_DESCRIPTION_MAX_LENGTH = 250;
export const API_SLOT_QUESTION_MAX_LENGTH = 100;
export const API_SLOT_DESCRIPTION_MAX_LENGTH = 250;
export const API_SLOT_NAME_MAX_LENGTH = 30;
export const API_EXAMPLE_MAX_LENGTH = 100;

export const primaryColor = '#4b4efc';

export const Source = {
    WEBSITE: 1,
    DOCUMENT: 2,
    API: 3,
    SURVEY: 4
};

export const SourceTypes = ['Websites', 'Documents', 'APIs', 'Surveys'];

export const SurveyQuestionType = {
    COMMENT_LIST: 'Comment List',
    RATING: 'Rating',
    RADIO_LIST: 'Radio List',
    STAR_RATING: 'Star Rating',
    CHECKBOX_LIST: 'Checkbox List',
    LANG_SELECTION: 'System_Lang_Selection'
};

export const SurveyFlow = {
    START: 1,
    INTENT_BASED: 2,
    END: 3
};

export const defaultBotPersonality =
    'You are ReCX AI Customer Assistant. Your role is to handle basic customer queries and respond with a precise answer.';
export const defaultGreetingMessage = 'Hi, I am ReCX AI Customer Assistant. How can I help you?';

export const defaultMaxTokens = 16;
export const defaultTemperature = 0;
export const defaultColor = '#101013';
export const defaultPublicAccess = false;

// Document
export const DocFileExt = ['pdf', 'docx', 'zip'];
export const MaxFileSizeLimit = 25 * 1_048_576; // 25MB

export const sourceTypeIcons = {
    document: "source-icon fa-regular fa-file-pdf",
    website: "source-icon fa-solid fa-browser",
    api: "source-icon fa-solid fa-sitemap",
};

// Action Form Field Registry
export const ActionFields = {
    MessageTypeField: 'messageType',
    StaticMessageField: 'staticMessage',
    ResponseParseField: 'responseParse',
    AnswerGenerationField: 'answerGeneration',
    StorageSlotField: 'storageSlot'
} as const;

// Slot Form Field Registry
export const SlotFields = {
    SendToField: 'sendTo',
    SlotNameField: 'slotName',
    SlotRequestParamNameField: 'requestParamName',
    SlotTypeField: 'slotType',
    FixedValue: 'fixedValue',
    SlotFieldTypeField: 'slotFieldType',
    SlotDescriptionField: 'slotDescription',
    MultipleOptionsTypeField: 'multipleOptionsType',
    multipleStaticOptionField: 'multipleStaticOption',
    MultipleSlotOptionField: 'multipleSlotOption',
    SlotParserField: 'slotParser',
    ReferenceSlotNameField: 'referenceSlotName',
    ReferenceSlotParserField: 'referenceSlotParser'
} as const;